import React from 'react'
import I1 from '../../Images/New/OMU/1.png'
import I2 from '../../Images/New/OMU/2.png'
import I3 from '../../Images/New/OMU/3.png'
import I4 from '../../Images/New/OMU/4.png'
import I5 from '../../Images/New/OMU/5.png'
import I6 from '../../Images/New/OMU/6.png'
import I7 from '../../Images/New/OMU/7.png'
import I8 from '../../Images/New/OMU/8.png'

const OMU = () => {
  return (
    <>
      <div className="relative flex justify-center py-12">
        <div className="w-full max-w-7xl px-10">
          <div className="sm:flex items-center">
            <div className="px-3 sm:px-0">
              <p className="mb-0 text-3xl font-bold text-black">
                Office <span className="">Management</span> Utilities
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 w-[94%] sm:px-0 px-3">
              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I1} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    My Invoice
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I5} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    PDF Signer
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I3} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    Easy Mail
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I7} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    Note writer
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I2} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    My <br />Documents
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I6} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    Document <br />storage
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I4} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    Work <br />Assigner
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 border-2 border-[#7decc6] py-1 px-2 rounded-lg bg-[#f8fafc] shadow-md">
                <div>
                  <img className="w-12" src={I8} alt="" />
                </div>
                <div>
                  <p className="mb-0 text-xl text-black font-semibold">
                    HSN/SAC <br />code
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OMU